import type React from 'react';

import { Separator } from '@change/ds-core-ui';

import { isSsr } from '@change-corgi/core/ssr';
import { getWindow } from '@change-corgi/core/window';

import { ReportAIIssueLink } from '#src/app/shared/components/abuse';

import { CampaignPhoto } from '../components/CampaignPhoto';
import { DmProfileStaffDrawer } from '../components/DmProfileStaffDrawer';
import { EndorsementsSection } from '../components/EndorsementsSection';
import { ProfileCard } from '../components/ProfileCard';
import { ResponseList } from '../components/ResponseList';
import { SapToDm } from '../components/SapToDm';
import { SummaryByAI } from '../components/SummaryByAI';
import { TargetedPetitionList } from '../components/TargetedPetitionList';
import { TopIssues } from '../components/TopIssues';
import { WebsitesContainer } from '../components/Websites';

import { useLayout } from './hooks/useLayout';

export const Layout: React.FC<EmptyProps> = () => {
	const {
		data: {
			dmReputationLayer: { isDmrlEnabled, hasCampaignPhotoOrWebsites, hasDmrlData },
		},
	} = useLayout();

	return (
		<>
			<div className="container pb-14">
				<ProfileCard />

				<div className="overflow-x-hidden px-4 md:px-0">
					<TargetedPetitionList />

					<ResponseList />

					{isDmrlEnabled && <TopIssues />}

					<SapToDm />

					{isDmrlEnabled && (
						<>
							<EndorsementsSection />

							{hasCampaignPhotoOrWebsites && <Separator orientation="horizontal" className="my-14" />}
							<div className="flex flex-col md:flex-row">
								<div className="order-2 md:order-1">
									<CampaignPhoto />
								</div>
								<div className="order-1 mb-5 md:order-2">
									<WebsitesContainer />
								</div>
							</div>

							{hasDmrlData && (
								<>
									<SummaryByAI />
									<div className="mb-5 md:mb-6" />
									<ReportAIIssueLink
										data-qa="dm-profile-report-ai-issue-link"
										pageUrl={isSsr() ? undefined : getWindow().location.href}
										type="generic"
									/>
								</>
							)}
						</>
					)}
				</div>
			</div>
			<DmProfileStaffDrawer />
		</>
	);
};
